<template>
  <section class='mvp-feedback'>
    <template v-if='sent'>
      <span class='mvp-feedback-thanks'>
        <b-icon icon='check-circle-fill' class='mr-1' />
        Obrigado pelo retorno!
      </span>
      <b-button variant='link' size='sm' class='p-0 ml-3' @click='sent = false'>Alterar resposta</b-button>
    </template>

    <template v-else>
      <span class='mvp-feedback-question'>Isso te ajudaria no seu dia a dia?</span>
      <b-button
        variant='outline-success'
        size='sm'
        :pressed='liked === true'
        :disabled='loading'
        @click='liked = true'
      >
        <b-icon icon='hand-thumbs-up' /> Sim
      </b-button>
      <b-button
        variant='outline-danger'
        size='sm'
        :pressed='liked === false'
        :disabled='loading'
        @click='liked = false'
      >
        <b-icon icon='hand-thumbs-down' /> Não
      </b-button>
      <b-form-textarea
        v-model='comment'
        class='mvp-feedback-comment'
        rows='1'
        max-rows='3'
        maxlength='1000'
        placeholder='Comentário (opcional)'
        :disabled='loading'
      />
      <b-overlay :show='sending' rounded opacity='0.6' spinner-small spinner-variant='primary'>
        <b-button variant='primary' size='sm' :disabled='liked === null || loading' @click='send'>
          Enviar
        </b-button>
      </b-overlay>
    </template>
  </section>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'MvpFeedbackBar',
  props: {
    mvpId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      sending: false,
      sent: false,
      liked: null,
      comment: ''
    }
  },
  methods: {
    ...mapActions('mvp', {
      handleGetMyMvpFeedback: 'handleGetMyMvpFeedback',
      handleSendMvpFeedback: 'handleSendMvpFeedback'
    }),
    notify(message, variant) {
      this.$bvToast.toast(message, {
        title: 'Atenção',
        variant,
        toaster: 'b-toaster-top-center',
        autoHideDelay: 4000
      })
    },
    async send() {
      this.sending = true
      try {
        await this.handleSendMvpFeedback({ id: this.mvpId, liked: this.liked, comment: this.comment })
        this.sent = true
      } catch (e) {
        this.notify('Não foi possível enviar o seu retorno. Tente novamente.', 'danger')
      } finally {
        this.sending = false
      }
    }
  },
  async mounted() {
    try {
      const feedback = await this.handleGetMyMvpFeedback(this.mvpId)
      if (feedback) {
        this.liked = feedback.liked
        this.comment = feedback.comment || ''
        this.sent = true
      }
    } catch (e) {
      this.sent = false
    } finally {
      this.loading = false
    }
  }
}
</script>

<style lang='scss' scoped>
.mvp-feedback {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 12px;
  background: #eef1f6;
  border: 1px solid #e2e6ee;
  border-radius: 8px;
}

.mvp-feedback-question {
  font-size: 14px;
  font-weight: 700;
  color: #022245;
}

.mvp-feedback-comment {
  flex: 1;
  min-width: 200px;
  font-size: 14px;
}

.mvp-feedback-thanks {
  font-size: 14px;
  font-weight: 600;
  color: #28a745;
}
</style>
